import * as React from 'react'

import { Button, type Icon } from '@factorialco/deprecated-design-system'

import { ExpiredTrialActionChecker } from 'modules/core/components/ExpiredTrialActionChecker'
import PanesHeader from 'modules/core/components/PanesHeader'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

interface Props {
  title: string
  description: string
  illustration: React.ComponentProps<typeof Icon.Large>['icon']
  addSchemaLabel: string
  canManageTables: boolean
  toggleModal: () => void
}

export default function CustomResourcesHeader({
  title,
  description,
  illustration,
  addSchemaLabel,
  canManageTables,
  toggleModal,
}: Props) {
  const {
    company: { subscription },
  } = useCurrentSession()

  return (
    <>
      <PanesHeader illustration={illustration} title={title} description={description} />
      {canManageTables && (
        <ExpiredTrialActionChecker subscription={subscription} onClick={toggleModal}>
          <Button.Decorative>{addSchemaLabel}</Button.Decorative>
        </ExpiredTrialActionChecker>
      )}
    </>
  )
}
